<template>
  <div>
    <Modal maxWidth="340" :show.sync="showCodeCreation" :close="closeOrderModal">
      <template v-slot:title>
        <span class="title">Nouveau code de parrainage </span>
      </template>
      <template v-slot:text>
        <v-text-field
          hide-details
          dense
          outlined
          v-model.number="code.ttl"
          label="Jours jusqu'à l'expiration"
          type="number"
          min="1"
          class="mb-2"
        />
         <v-text-field
          hide-details
          dense
          outlined
          v-model.number="code.discount"
          label="Réduction %"
          type="number"
          min="1"
          max="100"
          class="mb-2"
        />
        <v-text-field
          hide-details
          dense
          outlined
          v-model="code.iresa_code"
          label="IRESA code"
          type="text"
          class="mb-2"
        />
      </template>
      <template v-slot:actions>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn width="292" class="mr-2" @click="generateCode()" :disabled="!disabledButton" color="secondary">
            <v-icon>mdi-plus</v-icon>
            <span class="ml-2 d-none d-sm-inline-block">Générer le code</span>
          </v-btn>
        </v-row>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import { requests, utils } from '@/mixins/index';
import Modal from '@/components/Modal/Modal';

export default {
  mixins: [requests, utils],
  props: {
    customer: Object
  },
  components: {
    Modal
  },
  data () {
    return {
      code: {
        ttl:90,
        discount:10,
        iresa_code:''
      },
      showCodeCreation: false
    };
  },
  computed: {
    disabledButton () {
      let valid = true;
      if(!/^[a-zA-Z0-9]*$/g.test(this.code.iresa_code) || !this.code.iresa_code) {
        valid = false;
      }

      if(!Number.isInteger(this.code.discount) || this.code.ttl < 1 || this.code.discount > 100) {
        valid = false;
      }

      if(!Number.isInteger(this.code.ttl) || this.code.ttl < 1) {
        valid = false;
      }
      return valid;
    }
  },
  methods: {
    closeOrderModal () {
      this.ttl = 90,
      this.type = '',
      this.iresa_code = ''
      this.showCodeCreation = false;
    },
    async generateCode () {
      this.closeOrderModal();
      let notification = {
        message: "Génération de codes de réduction",
        type: 'info',
        timeout: 16000
      };

      EventBus.$emit('show-notifications', [notification]);
      const response = await this.generateReferralCode({ ...this.code, email:this.customer.email });
      if (!response.success) {
        notification = {
          message: response.message,
          type: 'danger'
        };

        EventBus.$emit('show-notifications', [notification]);
        return;
      }
      notification = {
          message: response.message,
          type: 'success'
      };
      EventBus.$emit('show-notifications', [notification]);
      EventBus.$emit('user-updated');
      return
    }
  },
  mounted () {
    EventBus.$on('startAddCode', () => {
      this.qrcode = null;
      this.showCodeCreation = true;
    });
  }
};
</script>
